module.exports = __webpack_public_path__ + "img/qingse.0d0b4093.png";